import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import SuperadminBreadcrumb from '../Superadmin/SuperadminBreadcrumb';

// ============================================================================
// Data Migrations Page
//
// One-time data migrations are added here temporarily while they are needed,
// then removed once they have been run against production. Earlier ones
// (ValueWithMetadata expansion/repair, door/window type consolidation, work
// order componentKeys, the 2026-09 takplan → structure/roofPlan migration,
// the 2026-09 photoLocation → photoLocations/{photoKey} migration, the
// 2026-10 "Vektorkälla för ritningar" migration, the 2026-10 "Flytta fast
// inredning" migration and the 2026-10 "Föräldralösa ytor" migration) have
// all been completed and removed.
//
// The page stays as the place for the next one.
// ============================================================================

const DataMigrations: React.FC = () => {
    useDocumentTitle('Datamigrering');

    return (
        <>
        <SuperadminBreadcrumb title="Datamigrering" />
        <Container className="py-4" style={{ maxWidth: 1000 }}>
            <h1 className="page-title mb-4">Datamigrering</h1>
            <Alert variant="secondary" className="mb-0">
                Det finns inga pågående datamigreringar.
            </Alert>
        </Container>
        </>
    );
};

export default DataMigrations;
